import {CONFIG} from '@/config';
import {KeyName, NameValues} from '@/modules/neodash/model/types/interfaces/NameValue';
import {ConstantsVirtualArea} from '@/modules/neodash/model/constants/locationType';
import {TypeLocalityLevelEnum} from '@/modules/neodash/model/types/enums/typeLocalityLevelEnum';
import {LocationTypeEnum} from '@/modules/neodash/model/types/enums/locationTypeEnum';
import {UserTypeEnum} from '@/modules/neodash/model/types/enums/userTypeEnum';
import {MitsubishStoresLocation, MitsubishStoresLocationAnnualPerformance} from '@/modules/neodash/model/types/interfaces/MitsubishStoresLocation';
import {VehicularReviewType} from '@/modules/neodash/model/types/interfaces/VehicularReviewType';
import {ServiceHelper, options} from '@/utils/service.helper';
import { ThroughputFilters } from '../model/types/interfaces/ThroughputFilters';

const baseUrl = `${CONFIG.URL.NEODASH_API}/api/Neodash`;

const userUrl = `${baseUrl}/User`;
const locationUrl = `${baseUrl}/Location`;
const storesLocationClientUrl = `${baseUrl}/storesLocationClient`;
const storeUrl = `${baseUrl}/Store`;
const urlGigDashFilter = `${CONFIG.URL.NEODASH_API}/api/gigDashFilters`;

type mapName = (id: number) => string;

export class FilterService {
  public static getVirtualArea = (): Promise<NameValues> =>
    FilterService.mapToKeyNamePromise(`${locationUrl}/virtualAreas`, ConstantsVirtualArea.getNameVirtualArea);

  public static getSegments = (): Promise<NameValues> =>
    FilterService.mapKeyNamePromise(`${urlGigDashFilter}/segments`, 'text', 'value');
  
  public static getThroughputFilters = (): Promise<ThroughputFilters> =>
    ServiceHelper.mapToPromise<ThroughputFilters>(`${urlGigDashFilter}/throughputFilters`, {
      method: 'get',
    });

  public static listCities = (): Promise<NameValues> =>
    FilterService.getLocationsByType(LocationTypeEnum.City);

  public static listCitiesUf = (idUf: number): Promise<NameValues> =>
    FilterService.mapToKeyNamePromise(`${locationUrl}/listCities/${idUf}`);

  public static listUfs = (): Promise<NameValues> =>
    FilterService.getLocationsByType(LocationTypeEnum.FederationUnit);

  public static getLocationsByType = (type: LocationTypeEnum): Promise<NameValues> =>
    FilterService.mapToKeyNamePromise(`${locationUrl}/locationsByType/${type}`);

  public static getLocalityVirtualArea = (type: number): Promise<NameValues> =>
    FilterService.mapToKeyNamePromise(`${locationUrl}/locationsByVirtualArea/${type}`);

  public static getTypeLocationByTypeResolutionLevel = (type: TypeLocalityLevelEnum): Promise<NameValues> =>
    FilterService.mapToKeyNamePromise(`${locationUrl}/typeLocationByTypeResolutionLevel/${type}`);

  public static getUserType = (): Promise<UserTypeEnum> =>
    ServiceHelper.mapToPromise<UserTypeEnum>(`${userUrl}/Type`);

  public static getMitsubishStoresLocation = (): Promise<MitsubishStoresLocation[]> =>
    ServiceHelper.mapToPromise<MitsubishStoresLocation[]>(`${storesLocationClientUrl}/Mitsubish`);

  public static getLocaleTypesMitsubishSegmentArea = (): Promise<MitsubishStoresLocation[]> =>
    ServiceHelper.mapToPromise<MitsubishStoresLocation[]>(`${storesLocationClientUrl}/MitsubishSegmentArea`);

  public static getMitsubishStoresLocationAnnualPerformance = (): Promise<MitsubishStoresLocationAnnualPerformance[]> =>
    ServiceHelper.mapToPromise<MitsubishStoresLocationAnnualPerformance[]>(`${storesLocationClientUrl}/MitsubishAnnualPerformance`);

  public static getVehicularReviewTypes = (): Promise<VehicularReviewType[]> =>
    ServiceHelper.mapToPromise<VehicularReviewType[]>(`${baseUrl}/vehicularReview/types`);

  public static getTypeLocationsFromMarketAnalysis = (): Promise<NameValues> =>
    FilterService.mapToKeyNamePromise(`${locationUrl}/typeLocationsByTheme/marketAnalysis`);

  public static getClientLocalesByType = (idType: number): Promise<NameValues> =>
    FilterService.mapToKeyNamePromise(`${locationUrl}/clientLocationsByType/${idType}`);

  public static getRegionalsFord = (): Promise<NameValues> =>
   FilterService.mapToKeyNamePromise(`${locationUrl}/regionalsFord`);

   public static getRegionalInfluenceAreasFord = (idsRegional: number[]): Promise<NameValues> =>
   {
      var options: options = {
        method: 'post',
        parameters: idsRegional
      };

      return FilterService.mapToKeyNamePromise(`${locationUrl}/influenceAreasFord`, null, options);
   };

  private static mapToKeyNamePromise = (url: string, mapperName: (mapName | null) = null,  options: options =  {method: 'get'}): Promise<NameValues> =>
    ServiceHelper.mapToPromise<KeyName[]>(url, options)
      .then(lst => lst.map(x => {
        const id = parseInt(x.id, 10);
        return {name: !!mapperName ? mapperName(id) : x.name, value: id}
      }).sortBy(x => x.name));

  private static mapKeyNamePromise = (url: string, propertyName: string, propertyValue: string,  options: options =  {method: 'get'}): Promise<NameValues> =>
    ServiceHelper.mapToPromise<KeyName[]>(url, options)
      .then(lst => lst.map(x => {
        return { name: x[propertyName], value: x[propertyValue] }
      }).sortBy(x => x.name));
}
